<template>
  <div class="gold_page">
    <h1>金币统计</h1>
    <div class="user-options clearfix">
      <!--<el-select style="width: 80px" v-model="curChannel.selectValue" placeholder="">-->
      <!--<el-option v-for="(item, itemIndex) in channels" v-bind:key="itemIndex" :label="item.label" :value="item.value"></el-option>-->
      <!--</el-select>-->
      <el-select
        style="width: 80px"
        v-model="curAction.selectValue"
        placeholder=""
      >
        <el-option label="获取" value="1"></el-option>
        <el-option label="消耗" value="2"></el-option>
      </el-select>
      <el-date-picker
        v-model="dateValue"
        value-format="yyyy-MM-dd"
        disabledDate="disabledDate"
        type="date"
        :picker-options="pickerOptions"
        placeholder="选择日期"
      >
      </el-date-picker>
      <el-button type="primary" @click="doInquery">查询</el-button>
    </div>
    <div class="display-type">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="表格" name="table" class="table-container">
          <div v-loading="loading">
            <CustomTable
              :tableList="tableList"
              :options="tableOptions"
              class="table"
            ></CustomTable>
          </div>
        </el-tab-pane>
        <el-tab-pane label="柱状图" name="bar" class="bar-container">
          <div v-loading="loading">
            <CustomBar :options="barOptions1" class="bar"></CustomBar>
            <CustomBar :options="barOptions2" class="bar"></CustomBar>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import CustomTable from '../../components/CustomTable'
import CustomBar from '../../components/CustomBar'

export default {
  components: {
    CustomTable,
    CustomBar
  },
  data() {
    return {
      curAction: {
        selectValue: '1',
        content: ''
      },
      curChannel: {
        selectValue: 'all',
        content: ''
      },
      channels: this.$store.state.channels,
      dateValue: this.$store.getters.dateOneDayBefore,
      pickerOptions: {
        disabledDate(date) {
          let dateNow = new Date()
          dateNow.setDate(dateNow.getDate() - 1)
          if (date.getTime() > dateNow.getTime()) {
            return true
          }
        }
      },
      tableOptions: {
        theader: [
          {
            name: 'name',
            label: '类型',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'count',
            label: '数量',
            sortable: true,
            fix: true,
            width: '160px'
          },
          {
            name: 'gold',
            label: '金币',
            sortable: true,
            fix: true,
            width: '220px'
          }
        ]
      },
      barOptions1: {
        title: '金币数量',
        legend: ['数量'],
        xAxis: {
          name: '类型',
          type: 'category',
          data: []
        },
        yAxis: {
          name: '数量',
          type: 'value'
        },
        series: [
          {
            name: '数量',
            type: 'bar',
            data: []
          }
        ]
      },
      barOptions2: {
        title: '金币金额',
        legend: ['金币'],
        xAxis: {
          name: '类型',
          type: 'category',
          data: []
        },
        yAxis: {
          name: '金币',
          type: 'value'
        },
        series: [
          {
            name: '金币',
            type: 'bar',
            data: []
          }
        ]
      },
      datePicked: [
        this.$store.getters.dateOneWeekBefore,
        this.$store.getters.dateOneDayBefore
      ],
      activeName: 'bar',
      tableList: [],
      loading: true
    }
  },
  beforeCreate() {},
  created() {
    this.getList()
  },
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    }
  },
  watch: {},
  methods: {
    datePickedChange(date) {
      this.datePicked = date
    },
    //获取视频通话数据
    getList() {
      this.loading = true
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.stats_query_golds,
        withCredentials: true,
        params: {
          username: this.username,
          token: this.token,
          start: this.dateValue,
          channel: this.curChannel.selectValue,
          action: this.curAction.selectValue
        }
      })
        .then(
          res => {
            if (res.data.code === 0) {
              this.tableListBuild(res.data.data)
              this.barOptionsBuild(res.data.data)
            } else if (res.data.code === 1001) {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
              this.$router.push(this.$route.query.redirect || '/login')
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error'
              })
            }
          },
          err => {
            this.$message({
              showClose: true,
              message: '请求错误:' + err,
              type: 'error'
            })
          }
        )
        .then(() => {
          this.loading = false
        })
    },
    //表格数据
    tableListBuild(data) {
      this.tableList = data
    },
    //柱状图配置
    barOptionsBuild(data) {
      this.barOptions1.xAxis.data = []
      for (let i = 0; i < this.barOptions1.series.length; i++) {
        this.barOptions1.series[i].data = []
      }
      this.barOptions2.xAxis.data = []
      for (let i = 0; i < this.barOptions2.series.length; i++) {
        this.barOptions2.series[i].data = []
      }
      let item
      for (let j in data) {
        item = data[j]
        this.barOptions1.xAxis.data.push(item.name)
        this.barOptions2.xAxis.data.push(item.name)

        this.barOptions1.series[0].data.push(item.count)
        this.barOptions2.series[0].data.push(item.gold)
      }
    },
    doInquery() {
      this.getList()
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.gold_page {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;

    .bar-container {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .bar {
        margin-left: 10px;
        display: inline-block;
        width: 900px;
        height: 300px;
      }
    }
  }
}
</style>
